import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0406 from "../../../lesson/course-04/lesson-06/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "e34ba3ba-cde0-4edf-abfe-f81e6344fa2b",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0406),
    lesson: lesson0406,
  },
];

export default lessonLinks;
